import { ShieldCheck } from "lucide-react";

export default function SafetyBanner({ className = "" }) {
  return (
    <div data-testid="safety-banner" className={`flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-200 px-4 py-3 ${className}`}>
      <ShieldCheck className="w-5 h-5 shrink-0 mt-0.5" />
      <p className="text-sm leading-relaxed">
        Per la tua sicurezza, incontratevi sempre in <strong>luoghi pubblici</strong> come in un supermercato, un bar affollato o un centro commerciale. Non condividere dati personali sensibili.
      </p>
    </div>
  );
}
